import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import parseHtml from 'html-react-parser'
import { parseScript } from '../../utils/parse-script'
import { useMemo } from 'react'
import { useDetectBot } from '@bluheadless/ui-logic/src/hooks/useDetectBot'

const parseOptions = {
	replace: (node) => {
		switch (node.type) {
			case 'script':
				return parseScript(node, { idPrefix: 'footer_script', strategy: 'lazyOnload' })
		}
	},
}

const Feet = () => {
	const { footerHtml: footerHtmlStringified } = useConfig()

	const { isBot, loading } = useDetectBot()

	const footerHtml = useMemo(
		() => (footerHtmlStringified && !loading && !isBot ? parseHtml(footerHtmlStringified, parseOptions) : null),
		[footerHtmlStringified, isBot, loading]
	)

	return <>{footerHtml}</>
}

export default Feet
